<template>
  <router-link to="/">Home</router-link>
</template>

<script>
import IdentifyAPI from '../../api/IdentifyAPI';
export default {
  data () {
    return {

    }
  },
  methods: {
    getToken () {
      const serviceType = this.$route.params.serviceType;
      const spNo = this.$route.query.spNo;
      IdentifyAPI.getToken(this.$route.query.code, `${process.env.VUE_APP_SERVER_PATH}/face/${serviceType}?spNo=${spNo}`)
        .then(res => {
          console.log(res);
          console.log(serviceType);
          if (serviceType === 'DRV_LIC_INTER') {
            this.$router.push({
              path: '/international',
              query: {
                token: res,
                authentication: 1,
                spNo: spNo
              }
            });
          }
          console.log(res);
        })
        .catch(err => {
          this.$error(err);
          this.$router.push({
            path: '/international',
            query: {
              authentication: 1
            }
          });
        })
    }
  },
  created () {
    if (this.$route.query.code) {
      this.getToken();
    } else {
      this.$message({
        type: 'error',
        message: this.$t('message.authentication_failed')
      });
      this.$router.push({
        path: '/international',
        query: {
          ...this.$route.query,
          authentication: 1
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
</style>